<template>
<footer class="text-gray-300 body-font font-mono text-micro bg-black flex justify-center px-5 md:py-4">
    <div class="flex flex-wrap text-center">
        <nav class="lg:text-xs list-none flex justify-center mb-4 mt-4 grid grid-cols-3 md:grid-cols-6 md:flex md:flex-row">
            <li class="p-1">
                <a class="hover:text-gray-600">
                    <router-link to="/"> home </router-link>
                </a>
            </li>
            <li class="p-1">
                <a class="hover:text-gray-600">
                    <router-link to="/shop-preview"> shop </router-link>
                </a>
            </li>
            <li class="p-1">
                <a class="hover:text-gray-600">
                    <router-link to="/news"> news </router-link>
                </a>
            </li>
            <li class="p-1">
                <a class="hover:text-gray-600">
                    <router-link to="/lifestyle"> lifestyle </router-link>
                </a>
            </li>
            <li class="p-1">
                <a class="hover:text-gray-600">
                    <router-link to="/about-us"> about </router-link>
                </a>
            </li>
            <li class="p-1">
                <a class="hover:text-gray-600">
                    <router-link to="/mailing-list"> mailing list </router-link>
                </a>
            </li>
            <li class="p-1">
                <a class="hover:text-gray-600">
                    <router-link to="/contact-us"> contact </router-link>
                </a>
            </li>
        </nav>
    </div>
</footer>
</template>

<script>
export default {
    name: 'Footer',
    components: {},
    computed: {
        isThankYouPathname() {
            return this.$route.name === 'thank-you';
        },
        isWhiteBackground() {
            return ['captcha', 'about-page', 'contact-page', 'products', 'mailing-list', '404', 'lifestyle-page'].indexOf(this.$route.name) > -1;
        }
    },
    data() {
        return {}
    }
}
</script>

<style>
.text-micro {
    font-size: 0.65rem;
    line-height: 0.9rem;
}
</style>
